const legacyScopeAliases: Record<string, string[]> = {
  'admin:action_approval_rules': ['admin:mpa_policies'],
  'read:action_approval_rules': ['read:mpa_policies'],
  'create:action_approval_rules': ['create:mpa_policies'],
  'update:action_approval_rules': ['update:mpa_policies'],
  'delete:action_approval_rules': ['delete:mpa_policies'],
  'update:action_approval_requests': ['update:mpa_requests'],
};

export const isScopeAuthorized = (scope: string, roleScopes: string[]) => {
  const [permission, action] = scope.split(':');
  const optionalScopes = [
    scope,
    `${permission}:all`,
    `admin:${action}`,
    'admin:all',
  ];
  const candidateScopes = optionalScopes.flatMap((x) => [
    x,
    ...(legacyScopeAliases[x] ?? []),
  ]);
  return candidateScopes.some((x) => roleScopes.includes(x));
};
